var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"el-select-dropdown__item",class:{
    'selected': _vm.select.id == _vm.value,
    'hover': _vm.hover
  },on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleClick($event)},"mousedown":function($event){$event.stopPropagation();$event.preventDefault();return _vm.selectOptionClick($event)},"mouseenter":_vm.hoverItem}},[_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dff5901a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/select/li.vue
// module id = null
// module chunks = 